import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../../constants/languages";
import Typography from "@material-ui/core/Typography";

export default class DiaTextDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.present.addText}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              fullWidth
              name="title"
              value={this.props.diaTextTitle}
              onChange={this.props.handleDiaTextTitleChange}
              label={languages.present.title}
            />
            <br />
            <br />
            <TextField
              autoFocus
              multiline
              rows="8"
              fullWidth
              name="diaText"
              value={this.props.diaText.replace(/<br \/>/g, "\n")}
              onChange={this.props.handleDiaTextChange}
            />
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
